$small-max: 992px;

fccd-facet-multi-select {
  width: 100%;

  .label hp5-label-decorator {
    position: absolute;
    left: -10000px;
    top: auto;
    width: 1px;
    height: 1px;
    overflow: hidden;
  }

  hp5-filter-panel div.content {
    padding: 0 !important;
  }
  // the options list gets hidden under mobile filter footer buttons, so set
  // the max height to be shorter on mobile
  @media (max-width: $small-max) {
    .optList {
      max-height: 150px !important;
    }
  }
}
